import serviceAnnouncementEdit from './service-announcement-edit.module'
export default serviceAnnouncementEdit
